import { GOALS } from '../lib/constants';

export function CompoundIcon({ compound, size = 16, style = {} }) {
  const g = GOALS[compound?.goal];
  if (!g) return <span style={{ fontSize: size * 0.9, ...style }}>💊</span>;
  const { Icon } = g;
  return <Icon size={size} style={{ color: compound?.color || g.color, ...style }} />;
}
